import React from 'react';

import css from './SearchForm.module.css';

// Modern magnifier — matches the site-wide search icon (ISOSearchBar): an
// upright lens (circle cx11 cy11 r7) with the handle running to 16.65,16.65.
const IconSearchDesktop = () => (
  <svg
    className={css.iconSvg}
    width="21"
    height="22"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
  >
    <g
      className={css.iconSvgGroup}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </g>
  </svg>
);

export default IconSearchDesktop;
